// Plain names for the technical task and queue names, so the lists read like a person wrote them. The technical name is
// always still shown (smaller) next to the plain one, because that is what logs, tickets and the backend use.
// A name not listed here gets a readable version of its technical name, so a new task never shows up blank.

export const TASK_NAMES = {
  "sync.metered.usage.report": "Metered usage ingest",
  "sync.metered.usage.backfill": "Metered usage backfill",
  "sync.copilot.budget.users.dispatch": "Copilot budgets: start bulk sync",
  "sync.copilot.budget.users.chunk": "Copilot budgets: one batch of users",
  "sync.copilot.budget.user": "Copilot budget: one user",
  "sync.copilot.usage.org.populate": "Copilot usage by organization",
  "sync.copilot.usage.user.report": "Copilot user usage report",
  "sync.copilot.usage.pipeline": "Copilot usage pipeline",
  "sync.copilot.usage.pipeline.backfill": "Copilot usage backfill",
  "sync.copilot.usage.pipeline.backfill.aggregate": "Copilot usage backfill: combine results",
  "sync.copilot.extract": "Copilot data extract",
  "sync.org.owners": "Organization owners",
  "sync.org.copilot_info": "Organization Copilot info",
  "sync.user.by_org": "Sync users for an organization",
  "sync.user.verify_pending": "Verify pending memberships",
  "sync.user.inactive_pipeline": "Inactive-user removals",
  "sync.user.pipeline": "User sync pipeline",
  "sync.user.remove_inactive": "Process inactive-user removals",
  "sync.user.cost_center": "Assign missing user cost centers",
  "sync.user.set_end_date": "Backfill removed users' end dates",
  "sync.cost_center.from_github": "Cost centers from GitHub",
  "recovery.stale": "Recover stale runs",
  "beat.refresh_schedule": "Scheduler refresh",
};

export const QUEUE_NAMES = {
  "sync.user": "Users",
  "sync.org": "Organizations",
  "sync.copilot": "Copilot",
  "sync.metered": "Metered usage",
  "sync.cost_center": "Cost centers",
};

// "sync.org.copilot_info" -> "Org copilot info"
const readable = (technical) => {
  const words = String(technical || "")
    .replace(/^sync\./, "")
    .split(/[._]/)
    .filter(Boolean)
    .join(" ");
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : String(technical || "—");
};

export const taskLabel = (name) => TASK_NAMES[name] || readable(name);
export const queueLabel = (queue) => (queue ? QUEUE_NAMES[queue] || readable(queue) : "—");
